import { inject } from "@angular/core";
import { finalize } from "rxjs";
import { HttpInterceptorFn } from "@angular/common/http";

import { LoadingService, systemLoader } from "../../services";

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  setTimeout(() => {
    if (req.context.get(systemLoader) === "loader") loadingService.setLoading(true, req.url);
  });

  return next(req).pipe(finalize(() => loadingService.setLoading(false, req.url)));
};
